// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","834":"94726e6d"}[chunkId] + "-" + {"125":"d48c0855546307f1e60d","223":"47d5750a980147b648f8","293":"2f05c4e79344ab6e8ecb","834":"055d11dae85329e55de0"}[chunkId] + ".js";
};